export default __webpack_public_path__ + "assets/images/image_carousel.84540357.png";